import { render } from "./QualityGroupDetails.vue?vue&type=template&id=2226e902"
import script from "./QualityGroupDetails.vue?vue&type=script&lang=js"
export * from "./QualityGroupDetails.vue?vue&type=script&lang=js"
/* custom blocks */
import block0 from "@/locales/components/views/packing_house/quality_control/process/show_inspect/quality_group_details.yml?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fhome%2Fnoe%2FDev%2Fatc%2Fagrotecchain_vue%2Fsrc%2Fcomponents%2Fviews%2Fpacking_house%2Fquality_control%2Fprocess%2Fshow_inspect%2FQualityGroupDetails.vue&lang=yaml"
if (typeof block0 === 'function') block0(script)


import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__